import React from 'react';
import Button from "@amzn/awsui-components-core/button";
import Icon from "@amzn/awsui-components-core/icon";
import { editIconStyles, removeIconStyles } from './design-tokens';

interface ActionButtonsProps {
    onEdit?: () => void;
    onDelete?: () => void;
    disabled?: boolean;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({ onEdit, onDelete, disabled = false }) => {
    return (
        <>
            {onEdit && (
                <Button
                    variant="link"
                    style={editIconStyles}
                    onClick={onEdit}
                    disabled={disabled}
                >
                    <Icon name="edit" size="small" variant={disabled ? "disabled" : "normal"} />
                </Button>
            )}
            {onDelete && (
                <Button
                    variant="link"
                    style={removeIconStyles}
                    onClick={onDelete}
                    disabled={disabled}
                >
                    <Icon name="remove" size="small" variant={disabled ? "disabled" : "normal"} />
                </Button>
            )}
        </>
    );
};

export default ActionButtons;
